import { getSimpleBoolSelectItems } from "@components/smart/FieldInfo";
import { BankStatementEntity, BankTransactionEntity } from "@odata/GeneratedEntityTypes";
import { ICreateFilterStringSettings } from "@odata/OData.utils";
import i18next from "i18next";

import { IAppContext } from "../../../contexts/appContext/AppContext.types";
import { FieldType, ValueType } from "../../../enums";
import BindingContext from "../../../odata/BindingContext";
import { IChangedFilter } from "../../../views/table/TableView.utils";
import { getDefinitions as getLoanDefinition } from "../../loans/statements/LoanStatementsDef";
import { IDefinition, IGetDefinition } from "../../PageUtils";
import { getDefinitions as getStatementDefinition } from "./../bankStatements/BankStatementsDef";

export const BankTransactionLocksFilterPath = BindingContext.localContext("Locks");


export const getCoreDefinition = (statementsDef: IDefinition): IDefinition => {
    statementsDef.table.preventStoreVariant = true;

    // mandatory default filter in pairing dialog
    statementsDef.table.filterBarDef[0].defaultFilters.push("BankAccount/IsActive");
    statementsDef.table.filterBarDef[0].filterDefinition["BankAccount/IsActive"] = {
        description: i18next.t("Banks:Statements.Account").toString()
    };

    statementsDef.table.filterBarDef[0].defaultFilters.push(BankTransactionLocksFilterPath);
    statementsDef.table.filterBarDef[0].filterDefinition[BankTransactionLocksFilterPath] = {
        type: FieldType.ComboBox,
        valueType: ValueType.Boolean,
        isValueHelp: false,
        label: i18next.t("Banks:Transactions.ShowLockedStatements").toString(),
        fieldSettings: {
            items: getSimpleBoolSelectItems()
        },
        filter: {
            buildFilter(item: IChangedFilter, settings: ICreateFilterStringSettings): string {
                const value = item.value as boolean;

                if (value) {
                    return "";
                }

                return `not(${BankTransactionEntity.Locks}/any())`;
            }
        },
        defaultValue: false
    };

    statementsDef.table.additionalProperties = [
        ...(statementsDef.table.additionalProperties ?? []),
        { id: BankStatementEntity.BankAccountBase },
        { id: "BankAccount/IsActive" }
    ];

    statementsDef.table.id = `${statementsDef.table.id}PairSpecialTable`;
    statementsDef.form.id = `${statementsDef.form.id}PairSpecialForm`;

    return statementsDef;

};

export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const statementsDef = getStatementDefinition(context, true);
    return getCoreDefinition(statementsDef);
};

export const getLoanPairStatementDefinition: IGetDefinition = (context: IAppContext): IDefinition => {
    const statementsDef = getLoanDefinition(context, true);
    return getCoreDefinition(statementsDef);
};

getDefinitions.translationFiles = ["Banks", "Document"];
getLoanPairStatementDefinition.translationFiles = ["Loans", "Banks", "Document"];